// 判断当前代码所在环境，自己可以按需要扩充

export const isPrivate = !(process.env.BRANCH_ENV === 'oa' || !process.env.BRANCH_ENV);
